(() => {
  'use strict';
  const config=JSON.parse(document.getElementById('offer-data').textContent);
  const state={quantity:1,extra:false,gallery:0};
  const previewSession=document.documentElement?.dataset.previewSession||'';
  let previewConnected=false;
  function reportState(){
    if(previewConnected)window.parent.postMessage({type:'bwl-preview-state',session:previewSession,state:{...state}},'*');
  }
  const $$=s=>Array.from(document.querySelectorAll(s));
  const $=s=>document.querySelector(s);
  const eur=c=>new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(c/100);
  const text=(selector,value)=>$$(selector).forEach(el=>{el.textContent=value;});
  const media=q=>document.getElementById('clock-media-'+q).innerHTML;
  const lamp=()=>document.getElementById('daylight-media').innerHTML;
  function calculate(quantity,extra){
    const bundle=config.bundles.find(b=>b.quantity===quantity);
    if(!bundle)throw new Error('Unknown bundle');
    const unit=config.bundles[0].price_cents;
    const reference=config.campaign.reference_unit_price_cents*quantity;
    const campaignSaved=(config.campaign.reference_unit_price_cents-unit)*quantity;
    const saved=unit*quantity-bundle.price_cents;
    const extraPrice=extra?config.accessory.price_cents:0;
    const extraReference=extra?(config.accessory.standalone_price_cents??config.accessory.price_cents):0;
    const extraSaved=extraReference-extraPrice;
    const shipping=config.shipping.price_cents;
    const shippingSaved=config.shipping.reference_price_cents-shipping;
    return {quantity,base:bundle.price_cents,extra:extraPrice,extraReference,extraSaved,reference,campaignSaved,saved,shipping,shippingSaved,total:bundle.price_cents+extraPrice+shipping,totalSaved:campaignSaved+saved+extraSaved+shippingSaved};
  }
  function summary(){return `${state.quantity} Lichtwecker${state.extra?' + 1 NordiLight':''}`;}
  function contents(){
    const q=state.quantity;
    return `<div class="p4-content-row">${media(q)}<div><strong>${q} × Lichtwecker in Grau</strong><small>${q} × Netzteil · ${q} × USB-Kabel (1,2 m)<br>${q} × Anleitung</small></div></div>`+(state.extra?`<div class="p4-content-row">${lamp()}<div><strong>1 × NordiLight Tageslichtlampe</strong><small>Deine separate Lampe für Schreibtisch oder Leseplatz.</small></div></div>`:'');
  }
  function orderLines(v){
    return `<div><span>${v.quantity} × Lichtwecker vor Rabatt</span><b>${eur(v.reference)}</b></div><div class="p4-invoice-saving"><span>30 % Herbst-Rabatt<small>auf deine Lichtwecker</small></span><b>− ${eur(v.campaignSaved)}</b></div>${v.saved?`<div class="p4-invoice-saving"><span>Zusätzlicher Mengenrabatt</span><b>− ${eur(v.saved)}</b></div>`:''}${v.extra?`<div><span>1 × NordiLight Tageslichtlampe<small>Einzelpreis im Shop</small></span><b>${eur(v.extraReference)}</b></div>${v.extraSaved?`<div class="p4-invoice-saving"><span>NordiLight-Kombivorteil</span><b>− ${eur(v.extraSaved)}</b></div>`:''}`:''}<div><span>Versand in Deutschland</span><span class="p4-line-shipping"><s>${eur(config.shipping.reference_price_cents)}</s><b>${eur(v.shipping)}</b></span></div>`;
  }
  function update(announce=true){
    const v=calculate(state.quantity,state.extra);
    text('[data-total],[data-sale-total]',eur(v.total));
    text('[data-base-total],[data-package-base]',eur(v.base));
    text('[data-package-duo]',eur(v.base+config.accessory.price_cents));
    text('[data-reference]',eur(v.reference+v.extraReference));
    text('[data-sale-saving]',eur(v.campaignSaved+v.saved+v.extraSaved)+' gespart');
    text('[data-sale-selection]',summary());
    text('[data-campaign-label]',state.extra?'30 % auf Lichtwecker':'30 % Rabatt');
    text('[data-count-description]',summary());
    text('[data-selection-summary]',summary()+' · jeweils mit Netzteil, Kabel und Anleitung');
    text('[data-quantity-label]',state.quantity+' Lichtwecker');
    text('[data-total-saved]',eur(v.totalSaved));
    text('[data-saving-caption]',v.extraSaved?'Rabatte, Kombivorteil und Versand':v.saved?'Rabatt, Mengenrabatt und Versand':'Rabatt und Versand');
    text('[data-bundle-note]',state.extra?'Im Kombipaket: '+state.quantity+' Lichtwecker und genau 1 NordiLight. Zu jedem Wecker gehören Netzteil, Kabel und Anleitung.':'Jeder Lichtwecker kommt mit eigenem Netzteil, Kabel und Anleitung.');
    $$('[data-quantity-saving]').forEach(el=>{el.hidden=!v.saved;el.textContent=eur(v.saved)+' zusätzlicher Mengenrabatt';});
    $$('[data-selected-media],[data-dock-media]').forEach(el=>{el.innerHTML=media(state.quantity);});
    $$('.p4-bundle-visual>.p4-clocks').forEach(el=>{el.outerHTML=media(state.quantity);});
    $$('[data-contents]').forEach(el=>{el.innerHTML=contents();});
    $$('[data-order-lines]').forEach(el=>{el.innerHTML=orderLines(v);});
    $$('input[name="quantity"]').forEach(el=>{el.checked=Number(el.value)===state.quantity;});
    $$('input[name="package"]').forEach(el=>{el.checked=(el.value==='duo')===state.extra;});
    if($('#nordilight-choice'))$('#nordilight-choice').checked=state.extra;
    if(announce)text('[data-announcement]',summary()+'. Gesamt '+eur(v.total)+'. Du sparst '+eur(v.totalSaved)+'. Versand kostenlos.');
    reportState();
  }
  function navigate(anchor,instant=false){
    const target=document.getElementById(anchor);
    if(!target)return;
    const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({behavior:instant||reduced?'auto':'smooth',block:'start'});
    const focusTarget=anchor==='bwl-angebote'?$(`input[name="quantity"][value="${state.quantity}"]`):target;
    if(!focusTarget.hasAttribute('tabindex')&&!['INPUT','BUTTON','A'].includes(focusTarget.tagName.toUpperCase()))focusTarget.setAttribute('tabindex','-1');
    focusTarget.focus({preventScroll:true});
  }
  // A fragment in srcdoc otherwise resolves against the embedding page URL.
  $$('a[href]').forEach(link=>link.addEventListener('click',e=>{
    if(e.defaultPrevented||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
    const href=link.getAttribute('href');
    if(!href?.startsWith('#')||!document.getElementById(href.slice(1)))return;
    e.preventDefault();navigate(href.slice(1));
  }));
  $$('input[name="quantity"]').forEach(el=>el.addEventListener('change',()=>{state.quantity=Number(el.value);update();}));
  $$('input[name="package"]').forEach(el=>el.addEventListener('change',()=>{state.extra=el.value==='duo';update();}));
  if($('#nordilight-choice'))$('#nordilight-choice').addEventListener('change',e=>{state.extra=e.target.checked;update();});
  $$('[data-enable-extra]').forEach(el=>el.addEventListener('click',()=>{
    state.extra=true;update();$('#bwl-angebote').scrollIntoView({behavior:'smooth',block:'start'});
    ($('#nordilight-choice')||$('input[name="package"][value="duo"]')).focus({preventScroll:true});
  }));
  $$('[data-choose-quantity]').forEach(el=>el.addEventListener('click',()=>{
    state.quantity=Number(el.dataset.chooseQuantity);update();$('#bwl-angebote').scrollIntoView({behavior:'smooth',block:'start'});
    $(`input[name="quantity"][value="${state.quantity}"]`).focus({preventScroll:true});
  }));
  $$('[data-sample-reviews]').forEach(root=>{
    const cards=Array.from(root.querySelectorAll('[data-sample-review]'));
    const filter=root.querySelector('[data-review-filter]');
    const more=root.querySelector('[data-review-more]');
    const bars=Array.from(root.querySelectorAll('[data-rating-filter]'));
    let limit=6;
    function showReviews(){
      const value=Number(filter.value);
      const matching=cards.filter(card=>!value||Number(card.dataset.rating)===value);
      cards.forEach(card=>{card.hidden=!matching.slice(0,limit).includes(card);});
      more.hidden=matching.length<=limit;
      root.querySelector('[data-review-status]').textContent=Math.min(limit,matching.length)+' von '+matching.length+' Bewertungen';
      bars.forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.ratingFilter)===value)));
    }
    filter.addEventListener('change',()=>{limit=6;showReviews();});
    bars.forEach(button=>button.addEventListener('click',()=>{filter.value=button.dataset.ratingFilter;limit=6;showReviews();}));
    more.addEventListener('click',()=>{limit=cards.length;showReviews();});
    showReviews();
  });
  $$('[data-mini-proof]').forEach(root=>{
    const track=root.querySelector('[data-mini-track]');
    const cards=Array.from(root.querySelectorAll('[data-mini-card]'));
    const dots=Array.from(root.querySelectorAll('[data-mini-dot]'));
    const nav=root.querySelector('[data-mini-dots]');
    let active=0;
    function mark(i){active=i;dots.forEach((dot,n)=>dot.setAttribute('aria-current',String(n===i)));}
    function position(i){return cards[i].offsetLeft-cards[0].offsetLeft;}
    function show(i){
      const next=Math.max(0,Math.min(cards.length-1,i));
      mark(next);
      const reduced=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({left:position(next),behavior:reduced?'auto':'smooth'});
    }
    function readPosition(){
      let nearest=0;
      cards.forEach((card,i)=>{if(Math.abs(position(i)-track.scrollLeft)<Math.abs(position(nearest)-track.scrollLeft))nearest=i;});
      mark(nearest);
    }
    dots.forEach((dot,i)=>dot.addEventListener('click',()=>show(i)));
    track.addEventListener('scroll',readPosition,{passive:true});
    track.addEventListener('keydown',e=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
      e.preventDefault();show(e.key==='Home'?0:e.key==='End'?cards.length-1:active+(e.key==='ArrowRight'?1:-1));
    });
    window.addEventListener?.('resize',readPosition,{passive:true});
    nav.hidden=cards.length<2;mark(0);
  });
  const slides=$$('.gallery-slide'),thumbs=$$('[data-slide]');
  function showSlide(i){
    state.gallery=(i+slides.length)%slides.length;
    slides.forEach((el,n)=>{el.hidden=n!==state.gallery;});
    thumbs.forEach((el,n)=>{el.setAttribute('aria-pressed',String(n===state.gallery));});
    text('[data-gallery-number]',`${state.gallery+1} / ${slides.length}`);
    text('[data-gallery-caption]',slides[state.gallery].dataset.caption);
    reportState();
  }
  thumbs.forEach(el=>el.addEventListener('click',()=>showSlide(Number(el.dataset.slide))));
  $$('[data-gallery-step]').forEach(el=>el.addEventListener('click',()=>showSlide(state.gallery+Number(el.dataset.galleryStep))));
  $('.thumbnails').addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();showSlide(state.gallery+(e.key==='ArrowRight'?1:-1));thumbs[state.gallery].focus();}});
  let opener=null;
  function openDialog(d,button){opener=button;d.showModal();d.querySelector('[data-close]').focus();}
  $$('[data-close]').forEach(el=>el.addEventListener('click',()=>el.closest('dialog').close()));
  $$('dialog').forEach(d=>{
    d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}});
    d.addEventListener('close',()=>{if(opener&&opener.isConnected)opener.focus();});
  });
  $('[data-zoom]').addEventListener('click',e=>{
    const original=slides[state.gallery].querySelector('img').cloneNode(false);
    original.className='zoom-original';original.removeAttribute('loading');
    $('#zoom-content').replaceChildren(original);text('#zoom-caption',slides[state.gallery].dataset.caption);
    openDialog($('#gallery-dialog'),e.currentTarget);
  });
  $$('[data-sample-zoom]').forEach(button=>button.addEventListener('click',()=>{
    const original=button.querySelector('img').cloneNode(false);
    original.className='zoom-original';original.removeAttribute('loading');
    $('#zoom-content').replaceChildren(original);
    text('#zoom-caption',button.dataset.photoCaption);
    openDialog($('#gallery-dialog'),button);
  }));
  $$('[data-add]').forEach(el=>el.addEventListener('click',()=>{
    const v=calculate(state.quantity,state.extra);
    $('#dialog-order').innerHTML=`<div class="p4-contents">${contents()}</div><div class="p4-invoice">${orderLines(v)}</div><div class="p4-grand"><span>Gesamt</span><strong>${eur(v.total)}</strong></div><div class="p4-saved"><span>Du sparst insgesamt</span><strong>${eur(v.totalSaved)}</strong></div>`;
    openDialog($('#order-dialog'),el);
  }));
  $$('[data-open-comparison]').forEach(el=>el.addEventListener('click',e=>{if(previewConnected){e.preventDefault();window.parent.postMessage({type:'bwl-navigate',page:'comparison',session:previewSession},'*');}}));
  window.addEventListener?.('message',e=>{
    const message=e.data;
    if(e.source!==window.parent||message?.type!=='bwl-preview-command'||message.session!==previewSession)return;
    if(message.action==='restore'){
      const value=message.state;
      if(!value||!config.bundles.some(b=>b.quantity===value.quantity))return;
      previewConnected=true;state.quantity=value.quantity;state.extra=!!value.extra;
      update(false);showSlide(Number.isInteger(value.gallery)?value.gallery:0);
    }else if(message.action==='navigate')navigate(message.anchor,!!message.instant);
  });
  update(false);showSlide(0);
  window.clockPreview={calculate,config,getState:()=>({...state}),setSelection:(quantity,extra)=>{calculate(quantity,extra);state.quantity=quantity;state.extra=!!extra;update(false);},showSlide};
  if(window.parent!==window)window.parent.postMessage({type:'bwl-preview-ready',page:'product',session:previewSession},'*');
})();
